/**
 * 利用ガイドのエントリーポイント。
 * /guide          → トップ（記事カタログ）
 * /guide/<slug>   → 個別記事
 */
import { GuideLayout } from "./GuideLayout.js";
import { TOC_SECTIONS } from "./GuideToc.js";
import { ARTICLES } from "./articles/index.js";

const PRIMARY = "#534AB7";

interface Props {
  slug: string | null; // null の場合はトップ表示
}

export default function GuidePage({ slug }: Props) {
  // ─── 個別記事 ───
  if (slug) {
    const article = ARTICLES[slug];
    if (!article) {
      return (
        <GuideLayout currentSlug={null} title="ページが見つかりません">
          <p>
            指定された記事は存在しません。
            <a href="/guide">ガイドトップに戻る</a>
          </p>
        </GuideLayout>
      );
    }
    const { Content } = article;
    return (
      <GuideLayout currentSlug={slug} title={article.title} updatedAt={article.updatedAt}>
        <Content />
      </GuideLayout>
    );
  }

  // ─── トップ（記事カタログ）───
  return (
    <GuideLayout currentSlug={null} title="利用ガイド">
      <p style={{ fontSize: 15, color: "#4a4a48", marginBottom: 32 }}>
        Sign Extension for クラウドサイン の使い方をまとめたガイドです。
        まずは「<a href="/guide/quick-start" style={{ color: PRIMARY }}>クイックスタート</a>」から始めるのがおすすめです。
      </p>

      {TOC_SECTIONS.map((section) => (
        <section key={section.id} style={{ marginBottom: 36 }}>
          <h2
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: PRIMARY,
              borderLeft: `4px solid ${PRIMARY}`,
              paddingLeft: 12,
              marginBottom: 14,
            }}
          >
            {section.title}
          </h2>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 10 }}>
            {section.articles.map((a) => (
              <li key={a.slug}>
                <a
                  href={`/guide/${a.slug}`}
                  style={{
                    display: "block",
                    padding: "12px 14px",
                    background: "#faf9f7",
                    borderRadius: 8,
                    border: "1px solid #e8e7e3",
                    textDecoration: "none",
                    color: "#2a2a28",
                    fontSize: 14,
                    fontWeight: 500,
                    transition: "background 0.1s",
                  }}
                >
                  {a.title}
                </a>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </GuideLayout>
  );
}
